// src/router/index.js

import { createRouter, createWebHistory } from 'vue-router'

// Importuj swoje komponenty — ścieżki dostosuj do swojej struktury projektu
import AppProductList from '../components/AppProductList.vue'
import AppProductDetail from '../components/AppProductDetail.vue'
// Przykładowo — dodaj inne podstrony:
import AppNewsletter from '../components/AppNewsletter.vue'
import AppProductCard from '@/components/AppProductCard.vue'
import AppCart from '../components/AppCart.vue'
import AppCheckout from '../components/AppCheckout.vue'
import AppOrderConfirmation from '../components/AppOrderConfirmation.vue'
import AppKontakt from '../components/AppKontakt.vue'
import AppWysylka from '../components/AppWysylka.vue'
import AppZwroty from '../components/AppZwroty.vue'
import AppRegulamin from '../components/AppRegulamin.vue'
import AppPolityka from '../components/AppPolityka.vue'
import AppUslugi from '../components/AppUslugi.vue'
import AppPayNowStatus from '@/components/AppPayNowStatus.vue'
import AppStripeStatus from '@/components/AppStripeStatus.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: AppProductList
  },
  {
    path: '/product/:slug',
    name: 'ProductDetail',
    component: AppProductDetail,
    props: true
  },
  {
    path: '/card',
    name: 'ProductCard',
    component: AppProductCard
  },
  {
    path: '/newsletter',
    name: 'Newsletter',
    component: AppNewsletter
  },
    {
    path: '/cart',
    name: 'Cart',
    component: AppCart
  },
  {
    path: '/podsumowanie',
    name: 'Podsumowanie',
    component: AppCheckout
  },
  {
    path: '/potwierdzenie',
    name: 'OrderConfirmation',
    component: AppOrderConfirmation
  },
  {
    path: '/kontakt',
    name: 'Kontakt',
    component: AppKontakt
  },
  {
    path: '/wysylka',
    name: 'Wysylka',
    component: AppWysylka
  },
   {
    path: '/zwrot',
    name: 'Zwrot',
    component: AppZwroty
  },
     {
    path: '/regulamin',
    name: 'Regulamin',
    component: AppRegulamin
  },
    {
    path: '/polityka',
    name: 'Polityka',
    component: AppPolityka
  },
   {
    path: '/uslugi',
    name: 'Uslugi',
    component: AppUslugi
  },
   {
    path: '/paynowstatus',
    name: 'Paynowstatus',
    component: AppPayNowStatus
  },
  {
    path: '/stripe-status',
    name: 'StripeStatus',
    component: AppStripeStatus
  },


]

// Utworzenie routera
const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition          // wstecz/przód
    if (to.hash) return { el: to.hash, top: 0 }      // kotwice
    return { left: 0, top: 0 }                       // domyślnie góra
  },
})

export default router
